import { store } from '../../../redux/store';
import _ from 'lodash';
import { addClassSvg, removeClassSvg } from './helpers';

export const showAndHideGrids = () => {
    const state = store.getState();
    const viewGrid = state.firstReducer.viewGridsReduxState;
    if (viewGrid) {
        _.forEach(document.getElementsByClassName('greenBoundary'),
           function (elem) { removeClassSvg(elem, 'hide'); });
     } else {
        _.forEach(document.getElementsByClassName('greenBoundary'),
           function (elem) { addClassSvg(elem, 'hide'); });
     }
}